import React from 'react';
import './index.scss';
const MetaCritic = (porps: any) => {
  let { dataList } = porps;
  return (
    <div className="dbi-meta-critic">
      {dataList?.map((item: any, index: any) => {
        return (
          <div className="dbi-meta-critic-item" key={index + '1'}>
            <span className="dbi-meta-critic-name">{item.name}:</span>
            <span className="dbi-meta-critic-value">{item.value}</span>
          </div>
        );
      })}
    </div>
  );
};
export default MetaCritic;
